import {
    postRouteLoading,
    postRouteRequest,
    postRouteSuccess,
    postRouteReject,
    postRouteReset
} from "../../actions/route/post";

export const postRoute = (formData) => async (dispatch, getState) => {
    dispatch(postRouteLoading());
    try {
        const { data } = await postRouteRequest(formData, getState);
        dispatch(postRouteSuccess(data))
    } catch (error) {
        dispatch(postRouteReject(error))
    } finally {
        setTimeout(() => { dispatch(postRouteReset()) }, 3000);
    }
    return Promise.resolve();
};